import React, { FC } from 'react';

import './spinner.scss';

interface Props {
  size?: 'small' | 'large';
}

const Spinner: FC<Props> = ({ size = 'small' }) => {
  return <div className={`spinner spinner-${size}`} />;
};

export default Spinner;
